import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1507.33867,693 L1386.69867,693 L1386.69867,572.36 L1612.08533,346.866667 L1732.832,467.506667 L1507.33867,693 Z M604.8,479.666667 C661.248,479.666667 690.03648,505.277333 718.397262,531.400213 L721.869725,534.599787 C750.24096,560.722667 779.296,586.333333 836.266667,586.333333 C890.833067,586.333333 919.563947,562.193269 946.973178,536.951966 L948.861673,535.209721 C949.490671,534.628577 950.119268,534.047131 950.747763,533.465663 L952.633237,531.721472 L952.633237,531.721472 L954.51988,529.978827 C956.093067,528.527733 957.669333,527.08 959.253333,525.64 C959.36,528.2 960,530.546667 960,533 L960,639.666667 C960,786.653333 840.32,906.333333 693.333333,906.333333 C546.346667,906.333333 426.666667,786.653333 426.666667,639.666667 L426.666667,575.666667 C450.741333,565.9184 468.449237,550.241451 485.993007,534.357582 L488.837484,531.780909 C517.761621,505.584672 547.150933,479.666667 604.8,479.666667 Z M1624.88533,183.24 C1653.36533,154.866667 1699.65867,154.76 1728.032,183.24 L1728.032,183.24 L1896.352,351.56 C1924.832,380.04 1924.832,426.333333 1896.352,454.813333 L1896.352,454.813333 L1572.832,778.333333 C1558.752,792.2 1540.61867,799.666667 1521.312,799.666667 L1521.312,799.666667 L1280.032,799.666667 L1280.032,558.386667 C1280.032,539.08 1287.49867,520.84 1301.04533,507.08 L1301.04533,507.08 Z M1108.05333,949 C1050.98667,937.053333 993.386667,928.306667 935.573333,921.373333 C1015.14667,852.786667 1066.66667,752.626667 1066.66667,639.666667 L1066.66667,533 C1066.66667,327.133333 899.2,159.666667 693.333333,159.666667 C487.466667,159.666667 320,327.133333 320,533 L320,639.666667 C320,752.413333 371.2,852.36 450.56,920.84 C392.96,927.88 335.573333,937.053333 278.826667,948.893333 C117.333333,982.92 0,1136.84 0,1314.97333 L0,1519.88 L21.6533333,1535.88 C150.293333,1630.81333 362.24,1746.54667 641.6,1759.66667 C658.773333,1760.41333 675.733333,1760.84 692.586667,1760.84 C1009.6,1760.84 1248,1621.85333 1364.90667,1535.98667 L1386.66667,1519.98667 L1386.66667,1315.08 C1386.66667,1136.94667 1269.44,983.026667 1108.05333,949",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPeerReviewSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPeerReviewSolid, _Component);

  var _super = _createSuper(IconPeerReviewSolid);

  function IconPeerReviewSolid() {
    _classCallCheck(this, IconPeerReviewSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPeerReviewSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPeerReview",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPeerReviewSolid.displayName = "IconPeerReviewSolid";
  return IconPeerReviewSolid;
}(Component);

IconPeerReviewSolid.glyphName = 'peer-review';
IconPeerReviewSolid.variant = 'Solid';
IconPeerReviewSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPeerReviewSolid;
export { IconPeerReviewSolid };